import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Popover,
  Tooltip,
} from "@mui/material";
import { twMerge } from "tailwind-merge";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";

import { getMuiIcon } from "utils/getMuiIcon";

const QuickMenuItem = ({ menu }) => {
  return (
    <div className="flex cursor-pointer items-start space-x-3 px-4 py-3 hover:bg-blue-50 dark:hover:bg-slate-800">
      {getMuiIcon(menu.icon, { color: "primary", fontSize: "small" })}
      <div>
        <div className="text-sm font-medium text-gray-500">{menu.title}</div>
        <div className="text-xs text-gray-500">{menu.subtitle}</div>
      </div>
    </div>
  );
};

const QuickActions = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const navigate = useNavigate();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const quickAccessMenus = [
    {
      title: "Shipment",
      subtitle: "Create New Shipment",
      icon: "LocalShippingOutlined",
      path: "/app/crm/shipment/create",
    },
    {
      title: "Collection",
      subtitle: "Create New Collection",
      icon: "LocalShipping",
      path: "/app/crm/collection/create",
    },
     {
      title: "Loading",
      subtitle: "Create New Loading",
      icon: "LocalShipping",
      path: "/app/crm/shipment-loading/create",
    },
    {
      title: "Warehouse",
      subtitle: "Assign Warehouse",
      icon: "WarehouseOutlined",
      path: "/app/crm/warehouse-allocation/create",
    },
    {
      title: "Branch Delivery",
      subtitle: "Create New Branch Delivery",
      icon: "LocalShippingTwoTone",
      path: "/app/crm/delivery/branch/delivery",
    },
    {
      title: "Door Delivery",
      subtitle: "Create New Door Delivery",
      icon: "LocalShippingTwoTone",
      path: "/app/crm/delivery/create",
    },
   

    // {
    //   title: "Alerts",
    //   subtitle: "View Alerts",
    //   icon: "GppMaybeOutlined",
    //   path: "/app/crm/university/create",
    // },
    // {
    //   title: "Course",
    //   subtitle: "New Course",
    //   icon: "MenuBookOutlined",
    //   path: "/app/crm/course/create",
    // },
  ];

  //   methods
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Quick Actions" arrow>
        <IconButton
          aria-describedby={id}
          variant="contained"
          color="primary"
          onClick={handleClick}
        >
          <AddCircleOutline
            color="primary"
            className={twMerge(
              "transform transition-transform duration-1000 ease-in-out",
              open && "rotate-45"
            )}
          />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        marginThreshold={12}
      >
        <Box
          sx={{
            width: { xs: "calc(100vw - 24px)", sm: 500 },
            maxWidth: 500,
          }}
        >
          <div className="px-5 pt-3 pb-2 font-medium text-gray-500">
            Quick Actions
          </div>

          <Divider />

          <Grid container>
            {quickAccessMenus.map((qm, index) => (
              <Grid key={`${qm.title}-${index}`} item xs={12} md={6}>
                <div
                  onClick={() => {
                    handleClose();
                    navigate(qm.path);
                  }}
                >
                  <QuickMenuItem menu={qm} />
                </div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Popover>
    </>
  );
};

export default QuickActions;
